import React from 'react';
import ReactDom from 'react-dom';
import { BrowserRouter, createBrowserHistory, initAsyncRouting } from '@thd-olt-component-react/router';
import { LayoutManagerProvider } from '@thd-olt-component-react/layout-manager';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '@thd-olt-component-react/theme-provider';
import B2BTheme from '@thd-olt-global/b2b-theme';
import { ContextBuilder, ExperienceProvider } from '@thd-nucleus/experience-context';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { ThdAnalytics } from '@thd-olt-component-react/thd-analytics';
import { DataProviderClient } from '@thd-nucleus/data-sources';
import { getHeadersForAPI } from '@thd-nucleus/request-manager/client';
import { App } from './App';
import { getServerProps } from './server-to-client';
import lmRules from './default-lm-rules.json'
import { getRoutes } from './routes';
import { name as experienceName } from '../project-config.json';

const { experienceContext, experienceProps } = ContextBuilder.client();

const history = createBrowserHistory();

ThdAnalytics.init();
NewRelicBridge.init();

document.addEventListener('DOMContentLoaded', function () {

  const node = document.getElementById('root');
  const render = window.DISABLE_SSR
    ? ReactDom.render
    : ReactDom.hydrate;
  const {
    currentRouteName,
    expConfiguration,
    asyncChunks,
    headers,
    themeName
  } = getServerProps();
  const theme = themeName === 'b2b' ? B2BTheme : null;

  Object.assign(headers, getHeadersForAPI());

  const routingConfig = {
    currentRouteName,
    routes: getRoutes(),
    asyncChunks,
    channel: experienceContext.channel
  }

  initAsyncRouting(routingConfig).then((currentRouteComponent) => {
    render(
      <ExperienceProvider value={experienceContext}>
        <LayoutManagerProvider featureSwitch={expConfiguration} context={lmRules}>
          <HelmetProvider>
            <BrowserRouter history={history} experience={experienceName}>
              <DataProviderClient
                headers={headers}
                debug={window.isDebugMode}
              >
                <ThemeProvider theme={theme}>
                  <App currentRouteName={currentRouteName} currentRouteComponent={currentRouteComponent} />
                </ThemeProvider>
              </DataProviderClient>
            </BrowserRouter>
          </HelmetProvider>
        </LayoutManagerProvider>
      </ExperienceProvider>,
      node
    );
  });
});
